export default 'DUCKS/SEO';
